var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),(_vm.isLoading)?_c('loading-spinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }